import { useState } from "react";
import styled from "styled-components";

const HelpToggle = styled.button`
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.brand};
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSize.xsmall};
  padding: 4px 0;
  text-decoration: underline;
  &:hover {
    opacity: 0.8;
  }
`;

const HelpPanel = styled.div`
  margin-top: 8px;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  border-radius: 6px;
  background: ${(props) => props.theme.colors.pageBodyBackground};
  font-size: ${(props) => props.theme.fontSize.xsmall};
  line-height: 1.8;
`;

const HelpTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const HelpTh = styled.th`
  text-align: left;
  padding: 6px 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  font-weight: bold;
  white-space: nowrap;
  width: 180px;
`;

const HelpTd = styled.td`
  padding: 6px 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors.secondaryBorder};
`;

const Code = styled.code`
  background: ${(props) => props.theme.colors.primaryBackground};
  border: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  border-radius: 3px;
  padding: 1px 4px;
  font-family: monospace;
  font-size: 12px;
`;

const HelpNote = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  background: ${(props) => props.theme.colors.primaryBackground};
  border-left: 3px solid ${(props) => props.theme.colors.brand};
  border-radius: 0 4px 4px 0;
  color: ${(props) => props.theme.colors.primaryText};
`;

export function MarkdownHelp() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <HelpToggle onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "▲ Markdown記法ヘルプを閉じる" : "▼ Markdown記法ヘルプ"}
      </HelpToggle>
      {isOpen && (
        <HelpPanel>
          <HelpTable>
            <tbody>
              <tr>
                <HelpTh>見出し</HelpTh>
                <HelpTd>
                  <Code># 大見出し</Code>　<Code>## 中見出し</Code>
                  <Code>### 小見出し</Code>
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>太字</HelpTh>
                <HelpTd>
                  <Code>**太字テキスト**</Code>
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>箇条書き</HelpTh>
                <HelpTd>
                  <Code>- 項目1</Code>{" "}
                  で箇条書き。インデント（半角スペース2つ）で入れ子に
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>番号付きリスト</HelpTh>
                <HelpTd>
                  <Code>1. 項目1</Code>　<Code>2. 項目2</Code>
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>リンク</HelpTh>
                <HelpTd>
                  <Code>[表示テキスト](https://example.com)</Code>
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>画像</HelpTh>
                <HelpTd>
                  「画像を挿入」ボタンから追加（自動でMarkdownが挿入されます）
                </HelpTd>
              </tr>
              <tr>
                <HelpTh>水平線</HelpTh>
                <HelpTd>
                  <Code>---</Code>（ハイフン3つ）
                </HelpTd>
              </tr>
            </tbody>
          </HelpTable>
          <HelpNote>
            💡 <strong>改行のコツ:</strong>{" "}
            改行するには空行（Enterを2回）を入れてください。
            1回のEnterだけでは改行されません。
          </HelpNote>
        </HelpPanel>
      )}
    </div>
  );
}
